<template>
  <div class="sign_view">
    <div class="query_wapper">
      <div class="query_item">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          style="width:150px"
          v-model="query.year"
          @change="selectYear"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.matchId"
          @change="selectMatch"
          style="width:200px;"
          placeholder="请选择赛事"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          :popper-append-to-body="false"
          v-model="query.id"
          placeholder="请选择学校"
          style="width:200px;"
          @change="getSignDetail"
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :value="item.id"
            :label="item.schoolName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.project !== 9" style="flex:1;">
        <el-button type="warning" style="width:90px;margin-right:8px;" @click="print">打印</el-button>
        <!-- <el-button type="primary" style="width:90px" @click="exportPdfRow">导出</el-button> -->
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="primary" @click="moveBack">返回</el-button>
      </div>
    </div>
    <div v-if="switchType === 1" class="table_box">
      <div class="box">
        <div class="left">
          <section class="head_title">
            <span>单位名称：</span>
            {{getSchoolName}}
          </section>
          <section class="head_title">
            <p>
              <span>领</span>
              <span>队：</span>
            </p>
            {{details.leaderName}}
          </section>
          <section class="head_title">
            <p>
              <span>教</span>
              <span>练：</span>
            </p>
            {{getCoachName}}
          </section>
        </div>
        <div class="right">
          <section class="head_title">
            <p>
              <span>组</span>
              <span>别：</span>
            </p>
            {{details.groupText}}
          </section>
          <section class="head_title">
            <span>联系电话：</span>
            {{details.leaderPhone}}
          </section>
          <section class="head_title">
            <span>联系电话：</span>
            {{details.coachPhones}}
          </section>
        </div>
      </div>
      <table
        style="border:1px solid #ddd;margin-top:20px;width:100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <thead>
          <tr>
            <template v-for="(item,index) in columns.slice(0,6)">
              <th
                colspan="1"
                rowspan="2"
                :key="index"
                :style="{width:item.width + 'px'}"
                class="ths big_title"
              >
                <div class="cell">{{item.title}}</div>
              </th>
            </template>
            <th
              class="ths big_title"
              :colspan="competitiveGymnasticsNum"
              style="border-bottom:1px solid #ddd"
            >
              <div class="cell">竞技操项目</div>
            </th>
            <th
              class="ths big_title"
              :colspan="nationalFitnessNum"
              style="border-bottom:1px solid #ddd"
            >
              <div class="cell">全民健身操项目</div>
            </th>
          </tr>
          <tr>
            <th
              v-for="(item,index) in columns.slice(6)"
              :key="index"
              class="ths big_title"
              :style="{width:item.width + 'px'}"
            >
              <div class="cell">{{item.title}}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in details.athleteList" :key=" index">
            <td style="text-align:center;color:#444;">
              <div class="cell">{{index + 1}}</div>
            </td>
            <template v-for="(temp,num) in columns.slice(1)">
              <td style="text-align:center;color:#444;" :key="num + '_' + index">
                <div class="cell">{{getKey(temp.key,index)}}</div>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <template v-if="details.matchName">
        <div
          v-if="details.state === 0"
          style="height:100px;color:#444;padding:20px;border:1px solid #ddd;border-top:none"
        >
          <section
            style="display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
          >
            <p style="font-size:24px">报名未提交</p>
          </section>
        </div>
        <div
          v-else
          :style="{height:details.state == 2 && userInfo.type === 4?'150px':'100px'}"
          style="width:100%;color:#444;padding:10px 20px;border:1px solid #ddd;border-top:none"
        >
          <p style="font-size:14px;">体育部意见：</p>
          <p
            style="font-size:24px;text-align:center;margin-top:10px;"
          >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
        </div>
      </template>
      <template v-else>
        <div class="table_list">
          <div style="height:100px;color:#444;padding:20px;border:1px solid #ddd;border-top:none">
            <section
              style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
            >
              <p>暂无数据</p>
            </section>
          </div>
        </div>
      </template>
    </div>
    <athletePhoto v-else :details="details"></athletePhoto>
    <div id="prints">
      <div style="page-break-after:always;">
        <h2 class="match_title">{{getMatchName}}</h2>
        <div class="box">
          <div class="left">
            <section class="head_title">
              <span>单位名称：</span>
              {{getSchoolName}}
            </section>
            <section class="head_title">
              <p>
                <span>领</span>
                <span>队：</span>
              </p>
              {{details.leaderName}}
            </section>
            <section class="head_title">
              <p>
                <span>教</span>
                <span>练：</span>
              </p>
              {{getCoachName}}
            </section>
          </div>
          <div class="right">
            <section class="head_title">
              <p>
                <span>组</span>
                <span>别：</span>
              </p>
              {{details.groupText}}
            </section>
            <section class="head_title">
              <span>联系电话：</span>
              {{details.leaderPhone}}
            </section>
            <section class="head_title">
              <span>联系电话：</span>
              {{details.coachPhones}}
            </section>
          </div>
        </div>
        <table
          class="unit"
          v-for="t in getTableNum"
          :style="{marginTop:t!== 1?'80px':''}"
          style="border:1px solid #ddd;margin-top:20px;width:100%;page-break-after:always"
          border="0"
          :key="t"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <tr>
              <template v-for="(item,index) in columns.slice(0,6)">
                <th
                  colspan="1"
                  rowspan="2"
                  :key="index"
                  :style="{width:item.width + 'px',borderRight:index == columns.length - 1?'none!important':'1px solid #999'}"
                  class="ths big_title"
                >
                  <div class="cell">{{item.title}}</div>
                </th>
              </template>

              <th
                class="ths big_title"
                :colspan="competitiveGymnasticsNum"
                style="border-bottom:1px solid #999;border-right:1px solid #999;min-width:100px"
              >
                <div class="cell">竞技操项目</div>
              </th>
              <th
                class="ths big_title"
                :colspan="nationalFitnessNum"
                style="border-bottom:1px solid #999;border-right:0;min-width:100px"
              >
                <div class="cell">全民健身操项目</div>
              </th>
            </tr>
            <tr>
              <th
                v-for="(item,index) in columns.slice(6)"
                :key="index"
                class="ths big_title"
                :style="{width:item.width + 'px',borderRight:index === (columns.slice(6).length - 1)?'none':'1px solid #999'}"
              >
                <div class="cell">{{item.title}}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in details.athleteList.slice((t -1) * 14,t* 14)" :key=" index">
              <td style="text-align:center;color:#444;border-right:1px solid #999">
                <div class="cell">{{t==1?(index + 1):(((t - 1) * 14) + index + 1)}}</div>
              </td>
              <template v-for="(temp,num) in columns.slice(1)">
                <td
                  :style="{borderRight:num == columns.length - 2?'none!important':'1px solid #999'}"
                  style="text-align:center;color:#444;"
                  :key="num + '_' + index"
                >
                  <div class="cell">{{getKey(temp.key,index)}}</div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <athletePhoto :details="details"></athletePhoto>
    </div>
  </div>
</template>
<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import athletePhoto from "../../aerobics/components/athletes-photo";
import { getMatchList } from "@/api/sports-management";
import { message, selectiveYear } from "@/common/js/mixins";
import { getCoachList } from "@/api/athletes.js";
export default {
  // 报名表查看
  components: {
    athletePhoto
  },
  mixins: [message, selectiveYear],
  props: {
    info: {
      type: Object
    },
    isListPrint: {
      type: Boolean
    }
  },
  data() {
    return {
      isShowBottom: true,
      loading: null,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      coachList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: "",
        id: "",
        matchId: ""
      },
      nationalFitnessNum: 0,
      competitiveGymnasticsNum: 0,
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "姓名",
          width: 100,
          key: "athleteName"
        },
        {
          title: "性别",
          width: 60,
          key: "genderText"
        },
        {
          title: "入学时间",
          width: 100,
          key: "startSchoolDateText"
        },
        {
          title: "学制",
          width: 100,
          key: "schoolSystemText"
        },
        {
          title: "注册号",
          width: 160,
          key: "registerNumber"
        }
      ]
    };
  },
  computed: {
    getTableNum() {
      const length = this.details.athleteList
        ? this.details.athleteList.length
        : 0;
      let num = 0;
      if (length > 18) {
        if (parseFloat(length / 18) > parseInt(length / 18)) {
          num = parseInt(length / 18) + 1;
        } else num = parseInt(length / 18);
      } else if (length > 0 && length <= 18) {
        num = 1;
      }
      return num;
    },
    getCoachName() {
      let coach = this.details.coachIds ? this.details.coachIds.split(",") : [];
      let arr = [];
      this.coachList.filter(item => {
        if (coach.includes(item.id)) {
          arr.push(item.name);
        }
      });
      return arr.join(",");
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 获取赛事名称
    getMatchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchId) {
          str = item.name;
          this.matchName = item.name;
        }
      });
      return str;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key) {
            switch (key) {
              case "groupId":
                keys =
                  this.details.athleteList[index][item.key] == 1
                    ? "甲组"
                    : this.details.athleteList[index][item.key] == 2
                    ? "乙组"
                    : this.details.athleteList[index][item.key] == 4
                    ? "丙组"
                    : "丁组";
                break;
              default:
                keys = this.details.athleteList[index][item.key];
                break;
            }
          }
        });
        return keys;
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.switchType = 1;
          Object.assign(this.query, {
            year: value.year,
            matchId: value.matchId,
            id: value.id
          });
          this.getMatch();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 导出pdf纵向
    exportPdf() {
      var that = this;
      document.documentElement.scrollLeft = 0;
      this.loading = this.$loading({
        lock: false,
        text: "PDF生成中...",
        spinner: "el-icon-loading"
      });
      that.isShowBottom = false;
      that.isShowBorder = false;
      let pageH =
        (document.querySelector("#prints").clientWidth / 595.28) * 841.89;
      let unit = document.querySelectorAll(".unit");
      let unitHeight = 0;
      unit.forEach((item, index) => {
        if ((index + 1) % 4 == 0) {
          item.style.marginTop = "220px";
        }
      });
      let athletePhoto = document.querySelectorAll(".photos");
      athletePhoto.forEach(item => {
        item.style.width = "100px";
        item.style.height = "120px";
      });
      let photos = document.querySelector(".athletes_photo");
      photos.style.border = "none";
      photos.style.padding = "0 20px";
      let rows = document.querySelectorAll(".rows");
      let rowsHeight =
        (document.querySelector(".headers").clientHeight * 841.89) / pageH;
      let rowsFlag = false;
      if (this.userInfo.project !== 7) {
        unit.forEach((item, index) => {
          if (index > 2) {
            var computedStyle;
            if (window.getComputedStyle) {
              computedStyle = getComputedStyle(item, null);
            } else {
              computedStyle = item.currentStyle; //兼容IE的写法
            }
            unitHeight +=
              (item.clientHeight * 841.89) / pageH +
              (computedStyle.marginBottom.split("px")[0] - 0);
          }
        });
        if (unit.length <= 3) {
          switch (unit.length) {
            case 1:
              photos.style.marginTop = 290 * 3 + "px";
              break;
            case 2:
              photos.style.marginTop = 260 * 2 + "px";
              break;
            default:
              photos.style.marginTop = 170 * 1 + "px";
              break;
          }
        } else {
          switch (unit.length % 3) {
            case 1:
              photos.style.marginTop =
                841 - unitHeight + (220 * 841.89) / pageH + 330 + "px";
              break;
            case 2:
              photos.style.marginTop = 360 * 2 + "px";
              break;
            default:
              photos.style.marginTop =
                841 - unitHeight + (220 * 841.89) / pageH + 50 + "px";
              break;
          }
        }
        rows.forEach((item, index) => {
          rowsHeight += (item.clientHeight * 841.89) / pageH;
          if (rowsHeight > 841.89 && index <= 4) {
            item.style.marginTop =
              ((item.clientHeight * 841.89) / pageH) * 2 + "px";
            item.style.borderTop = "1px solid #999";
            rowsFlag = true;
          } else if (rowsHeight > 841.89 && index > 4 && !rowsFlag) {
            item.style.marginTop = "100px";
            item.style.borderTop = "1px solid #999";
          }
        });
      } else {
        photos.style.marginTop = "260px";
      }
      let leftBorder = document.querySelectorAll(".left_border");
      leftBorder.forEach((item, index) => {
        item.style.borderLeft = "1px solid #999";
      });
      let exportPdfRight = document.querySelectorAll(".export_pdf_right");
      exportPdfRight.forEach((item, index) => {
        item.style.borderRight = "1px solid #999";
      });
      let exportPdfBottom = document.querySelectorAll(".export_pdf_bottom");
      exportPdfBottom.forEach((item, index) => {
        item.style.borderBottom = "1px solid #999";
      });
      this.$nextTick(() => {
        html2Canvas(document.querySelector("#prints"), {
          allowTaint: true,
          dpi: 192,
          useCORS: true
        }).then(canvas => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 842;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(that.details.matchName + ".pdf");
          that.loading.close();
          photos.style.border = "1px solid #999";
          photos.style.padding = "0";
          photos.style.marginTop = "0";
          athletePhoto.forEach(item => {
            item.style.width = "150px";
            item.style.height = "170px";
          });
          unit.forEach((item, index) => {
            if ((index + 1) % 4 == 0) {
              item.style.marginTop = "20px";
            }
          });
          rows.forEach((item, index) => {
            if ((index + 1) % 5 == 0 && index !== 0) {
              item.style.marginTop = "0";
              item.style.borderTop = "none";
            }
          });
          leftBorder.forEach((item, index) => {
            item.style.borderLeft = "none";
          });
          exportPdfRight.forEach((item, index) => {
            item.style.borderRight = "none";
          });
          exportPdfBottom.forEach((item, index) => {
            item.style.borderBottom = "none";
          });
          that.isShowBorder = true;
          that.isShowBottom = true;
        });
      });
    },
    // 导出pdf横向
    exportPdfRow() {
      var that = this;
      document.documentElement.scrollLeft = 0;
      that.isShowBottom = false;
      that.isShowBorder = false;
      let photos = document.querySelector(".athletes_photo");
      photos.style.border = "none";
      photos.style.padding = "0 20px";
      this.$nextTick(() => {
        html2Canvas(document.querySelector("#prints"), {
          allowTaint: true,
          dpi: 192,
          useCORS: true
        }).then(canvas => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.2) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (595.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(that.details.matchName + ".pdf");
          // that.loading.close();
          photos.style.border = "1px solid #999";
          photos.style.padding = "0";
          that.isShowBorder = true;
          that.isShowBottom = true;
        });
      });
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
        })
        .catch(err => {});
    },
    // 打印
    print() {
      if (this.schoolList.length === 0) {
        return this.openWarn("当前赛事暂无数据打印");
      }
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .athlete_name {font-size:14px!important}' +
            ".athlete_regist_number{font-size:12px!important } .border_bottom {border-bottom:1px solid #999!important} .border_top {border-top:1px solid #999!important}" +
            ".border_right {border-right:1px solid #999!important} .border_left {border-left:1px solid #999!important} .margin_top {margin-top:20mm!important}" +
            ".match_title {margin:10mm 0 20px;text-align:left;font-size:22px;font-family:PF;font-weight:bold;} .athletes_photo header h2 {margin:0;padding:0}" +
            ".athletes_photo header h1 {font-size:24px;margin:0 0 14px} .athletes_photo {margin:10px 0 0 0!important}" +
            ".athletes_photo header {text-align: center;padding: 44px 0;margin:0;color: #444;font-weight: 600;} .big_title {font-size: 14px;}.small_title {font-size: 12px;}" +
            "table {border:1px solid #999!important} table thead .ths p {margin:0;padding:0} table thead .ths {height: 40px;box-sizing: border-box;vertical-align: middle;font-size:14px!important;border-right:2px solid #999}" +
            "table tbody td .cell {color:#000} table tbody td {padding: 8px 2px;font-size: 13px;vertical-align: middle;border-top: 1px solid #999;border-right:1px solid #999}" +
            ".head_title {font:500 18px pfSem;line-height: 1;color: #444;padding:0;margin: 0 30px 15px 0;min-width: 300px;display:flex;align-items:center;}" +
            ".head_title>span,.head_title>p {display:flex;align-items:center;width: 90px;justify-content:space-between;line-height:1;margin:0;padding:0;flex-shrink:0}" +
            ".athlete_infos {padding:10px 5px!important} .box {display: flex;flex-wrap: wrap}" +
            ".page_break {margin-top:15mm!important} .info {margin-bottom:20px} table {margin-top:20px}  main {margin:15mm 0} h1 { margin:5mm 0 40px 0;font-size:24px;text-align:center }" +
            '</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    },
    // 返回上级
    moveBack() {
      Object.assign(this.query, this.$options.data().query);
      this.$emit("backs");
    },
    // 切换按钮组
    selectType(switchType) {
      this.switchType = switchType;
    },
    // 选择年份
    selectYear() {
      this.query.matchId = "";
      this.query.id = "";
      this.matchList = [];
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.getMatch();
    },
    // 获取赛事
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
          this.getList();
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      this.query.id = "";
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.matchList.filter(item => {
        if (item.id === value) {
          this.matchName = item.name;
        }
      });
      this.getList();
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id })
        .then(res => {
          this.columns = [
            {
              title: "序号",
              width: 60
            },
            {
              title: "姓名",
              width: 100,
              key: "athleteName"
            },
            {
              title: "性别",
              width: 60,
              key: "genderText"
            },
            {
              title: "入学时间",
              width: 100,
              key: "startSchoolDateText"
            },
            {
              title: "学制",
              width: 100,
              key: "schoolSystemText"
            },
            {
              title: "注册号",
              width: 160,
              key: "registerNumber"
            }
          ];
          let competitiveGymnasticsLen = 0;
          let nationalFitnessLen = 0;
          // 获取竞技操项目、健身操项目报名项目的最大值
          res.athleteList.filter((item, index) => {
            var competitive = item.projectJson.competitiveGymnastics.split(",")
              .length;
            competitiveGymnasticsLen =
              competitiveGymnasticsLen < competitive
                ? competitive
                : competitiveGymnasticsLen;
            var national = item.projectJson.nationalFitness.split(",").length;
            nationalFitnessLen =
              nationalFitnessLen < national ? national : nationalFitnessLen;
          });
          if (res.athleteList.length > 0) {
            res.athleteList.filter((item, index) => {
              const competitiveGymnastics = item.projectJson.competitiveGymnastics.split(
                ","
              );
              const nationalFitness = item.projectJson.nationalFitness.split(
                ","
              );
              let obj = {};
              // 判断每一个运动员报名竞技操项目的数量是否小于所有报名运动员中的最大数量,如果小于,则根据小于的数量,添加空格
              if (competitiveGymnastics.length < competitiveGymnasticsLen) {
                const le =
                  competitiveGymnasticsLen - competitiveGymnastics.length;
                let arr = [];
                for (let i = 0; i < le; i++) {
                  arr.push("");
                }
                competitiveGymnastics.splice(1, 0, ...arr);
              }
              // 判断每一个运动员报名全民健身操项目的数量是否小于所有报名运动员中的最大数量,如果小于,则根据小于的数量,添加空格
              if (nationalFitness.length < nationalFitnessLen) {
                const le = nationalFitnessLen - nationalFitness.length;
                let arr = [];
                for (let i = 0; i < le; i++) {
                  arr.push("");
                }
                nationalFitness.splice(1, 0, ...arr);
              }
              competitiveGymnastics.filter((item, i) => {
                obj["competitiveGymnastics" + i] = item;
              });
              nationalFitness.filter((item, i) => {
                obj["nationalFitness" + i] = item;
              });
              Object.assign(res.athleteList[index], {
                ...obj
              });
              if (index == 0) {
                competitiveGymnastics.filter((item, index) => {
                  this.columns.push({
                    key: "competitiveGymnastics" + index,
                    width: "130",
                    title: "参赛项目" + (index + 1)
                  });
                });
                nationalFitness.filter((item, index) => {
                  this.columns.push({
                    key: "nationalFitness" + index,
                    width: "130",
                    title: "参赛项目" + (index + 1)
                  });
                });
                this.competitiveGymnasticsNum = competitiveGymnastics.length;
                this.nationalFitnessNum = nationalFitness.length;
              }
            });
          }
          this.details = res;
          this.selectType(this.switchType);
          this.tableData = JSON.parse(JSON.stringify(res.swimAthleteList));
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 列表数据
    getList() {
      signList({
        ...this.query,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.schoolList = res.list;
          if (this.query.id) this.getSignDetail(this.query.id);
          else {
            if (res.list.length > 0 && this.query.matchId) {
              this.query.id = res.list[0].id;
              this.getSignDetail(this.query.id);
            } else {
              this.columns = [
                {
                  title: "序号",
                  width: 60
                },
                {
                  title: "姓名",
                  width: 100,
                  key: "athleteName"
                },
                {
                  title: "性别",
                  width: 60,
                  key: "genderText"
                },
                {
                  title: "入学时间",
                  width: 100,
                  key: "startSchoolDateText"
                },
                {
                  title: "学制",
                  width: 100,
                  key: "schoolSystemText"
                },
                {
                  title: "注册号",
                  width: 160,
                  key: "registerNumber"
                }
              ];
            }
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getCoachLists();
    this.getYearLists(this.query);
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/font/pfSembold.css";
.big_title {
  font-size: 15px;
}
.small_title {
  font-size: 12px;
}
.table_box {
  > .box {
    display: flex;
    flex-wrap: wrap;
  }
}
.head_title {
  color: #444;
  font: 500 18px pfSem;
  line-height: 1;
  margin: 0 50px 15px 0;
  min-width: 350px;
  display: flex;
  align-items: center;
  > span,
  > p {
    display: flex;
    align-items: center;
    width: 74px;
    justify-content: space-between;
  }
}
.select {
  background: #1e63b0;
  color: #fff;
}
.normal {
  background: transparent;
  color: #999;
}
table {
  thead {
    .ths {
      background: #eee;
      height: 40px;
      box-sizing: border-box;
      vertical-align: middle;
      &:not(:last-of-type) {
        border-right: 1px solid #ddd;
      }
    }
  }
  tbody {
    td {
      padding: 8px 2px;
      font-size: 14px;
      vertical-align: middle;
      border-top: 1px solid #ddd;
      &:not(:last-of-type) {
        border-right: 1px solid #ddd;
      }
    }
  }
}
#prints {
  position: absolute;
  left: -100000px;
  top: -100000px;
  //   opacity: 0;
  .box {
    display: flex;
    flex-wrap: wrap;
  }

  .head_title {
    color: #444;
    font: 500 18px pfSem;
    line-height: 1;
    margin: 0 50px 15px 0;
    min-width: 350px;
    display: flex;
    align-items: center;
    > span,
    > p {
      display: flex;
      align-items: center;
      width: 74px;
      justify-content: space-between;
    }
  }
}
</style>